namespace RioERP.Reports {
    export interface B2CRow {
        Id?: number;
        InvoiceDate?: string;
        Invoicenumber?: string;
        EPaymentType?: RioErp.Web.Enums.PaymentType;
        PaymentSource?: string;
        Views?: Web.Enums.EOpens;
        Validity?: Web.Enums.EValidity;
        SpecificationName?: string;
        CustomerName?: string;
        StateName?: string;
        Quantity?: number;
        HsnCode?: string;
        TaxCategoryName?: string;
        ProductName?: string;
        TaxRate?: number;
        TaxableAmount?: number;
        CgstAmount?: number;
        SgstAmount?: number;
        IgstAmount?: number;
        NetAmount?: number;
        OrderNumber?: string;
        City?: string;
        DiscountAmount?: number;
        Gstin?: string;
        OrderDate?: string;
    }

    export namespace B2CRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Invoicenumber';
        export const localTextPrefix = 'Reports.B2C';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            InvoiceDate = "InvoiceDate",
            Invoicenumber = "Invoicenumber",
            EPaymentType = "EPaymentType",
            PaymentSource = "PaymentSource",
            Views = "Views",
            Validity = "Validity",
            SpecificationName = "SpecificationName",
            CustomerName = "CustomerName",
            StateName = "StateName",
            Quantity = "Quantity",
            HsnCode = "HsnCode",
            TaxCategoryName = "TaxCategoryName",
            ProductName = "ProductName",
            TaxRate = "TaxRate",
            TaxableAmount = "TaxableAmount",
            CgstAmount = "CgstAmount",
            SgstAmount = "SgstAmount",
            IgstAmount = "IgstAmount",
            NetAmount = "NetAmount",
            OrderNumber = "OrderNumber",
            City = "City",
            DiscountAmount = "DiscountAmount",
            Gstin = "Gstin",
            OrderDate = "OrderDate"
        }
    }
}
